import React from 'react';

type LabelTextBoxProps = {
  labelText: string;
  containerStyle?: any;
  labelStyle?: any;
  inputStyle?: any;
  inputValue?: any;
  onChange?: any;
  onBlur?: any;
  error?: boolean;
  onKeyPressProps?: any;
  disabled?: boolean;
  readOnly?: boolean;
};

export default function LabelTextBox({
  labelText,
  containerStyle,
  labelStyle,
  inputStyle,
  inputValue,
  onChange,
  onBlur = null,
  error = false,
  onKeyPressProps = null,
  disabled = false,
  readOnly = false,
}: LabelTextBoxProps) {
  function onKeyPress(e) {
    if (onKeyPressProps) {
      onKeyPressProps(e);
    }
  }

  const identifier = labelText.toLowerCase().replaceAll(' ', '');

  return (
    <div
      id={`labeltextbox-${identifier}-wrapper`}
      data-testid={`labeltextbox-${identifier}-wrapper`}
      style={{ width: '100%', marginTop: '1.6%', ...containerStyle }}
    >
      <label
        id={`labeltextbox-label-${identifier}`}
        data-testid={`labeltextbox-label-${identifier}`}
        style={{ width: '19.52%', fontSize: '0.8125rem', ...labelStyle }}
      >
        {labelText}
      </label>
      <input
        id={`labeltextbox-${identifier}-input-text`}
        data-testid={`labeltextbox-${identifier}-input-text`}
        className={error ? 'input-error' : ''}
        style={{
          width: '80.48%',
          height: '2.125rem',
          padding: '5px',
          ...inputStyle,
        }}
        onKeyPress={onKeyPress}
        value={inputValue}
        onChange={onChange}
        onBlur={onBlur}
        type="text"
        readOnly={readOnly}
        disabled={disabled}
      />
    </div>
  );
}
